import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class MinSubmergedUnitWeightGamaSubMinCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (MinSubmergedUnitWeightGamaSubMinCalculationMethodModel._instance == null) MinSubmergedUnitWeightGamaSubMinCalculationMethodModel._instance = new MinSubmergedUnitWeightGamaSubMinCalculationMethodModel(authManager);
        return MinSubmergedUnitWeightGamaSubMinCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/min-submerged-unit-weight-gama-sub-min-calculation-methods', 'geo-sections/min-submerged-unit-weight-gama-sub-min-calculation-methods/codelist');

        this.entityName = 'geo-sections.MinSubmergedUnitWeightGamaSubMinCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Min Submerged Unit Weight Gama Sub Min Calc Method';
        this.setLabel = 'Min Submerged Unit Weight Gama Sub Min Calc Methods';

        this.browser = {
            name: 'default-geo-sections-minsubmergedunitweightgamasubmincalculationmethod-browser',
            moduleName: 'default-geo-sections-minsubmergedunitweightgamasubmincalculationmethod-browser',
            moduleTitle: 'Min Submerged Unit Weight Gama Sub Min Calc Methods',
            moduleStateSlotName: 'default-geo-sections-minsubmergedunitweightgamasubmincalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-minsubmergedunitweightgamasubmincalculationmethod-editor',
            moduleName: 'default-geo-sections-minsubmergedunitweightgamasubmincalculationmethod-editor',
            moduleTitle: 'Min Submerged Unit Weight Gama Sub Min Calc Method',
            moduleStateSlotName: 'default-geo-sections-minsubmergedunitweightgamasubmincalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
